import script from "./GasStorage.vue?vue&type=script&lang=ts&setup=true"
export * from "./GasStorage.vue?vue&type=script&lang=ts&setup=true"

import "./GasStorage.vue?vue&type=style&index=0&id=eadc5352&lang=scss"

const __exports__ = script;

export default __exports__